import type { CreateCexDataDefaultParameters } from '../../types'
import { createCexData } from '../../utils/createCexData'
import { fetchSpotTradeHistories } from './fetchData'
import { parseSpotTradeHistoriesToActions } from './parseToActions'
import type { Trade } from './schema'

const limit = 500

export const createKucoinSpotTradeHistoryData = async (
  parameters: Omit<CreateCexDataDefaultParameters, 'limit' | 'desc'>,
) =>
  createCexData<Trade>({
    ...parameters,
    limit,
    desc: true,
    fetchAllData: async (parameters) => {
      if (parameters.password === undefined) {
        throw new Error('password is required')
      }
      const data = await fetchSpotTradeHistories({
        ...parameters,
        password: parameters.password,
        limit,
      })

      // sort
      const sortedData = data.toSorted((a, b) => a.createdAt - b.createdAt)
      return {
        data: sortedData,
        from: sortedData.length > 0 ? sortedData[0].createdAt : undefined,
        to:
          sortedData.length > 0
            ? sortedData[sortedData.length - 1].createdAt
            : undefined,
      }
    },
    parseToActions: parseSpotTradeHistoriesToActions,
    parseToAccountIds: () => [],
    parseToSources: () => [],
  })
